/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { backgroundColor, } from './style.js'
import React from 'react'
import { Header } from './header'
import { Account } from './account'
import { Footer } from './footer'
import { useOrderTicket } from './use-order-ticket'
import { isNumeric, fmt, showModal, arrayFrom, show, parseHtml, openWindow } from '../twd'

export const Confirm = () => {

    return <React.Fragment>

        <div className="container order-ticket">
        <Header />
        </div>

        <div style={{backgroundColor:"#f6f6f6"}}>
        <div className="container">
            <Account />
        </div>
        </div>

        <div css={backgroundColor}>
        <div className="xs-hide container">
            <Content />
        </div>
        <div className="xs-show container">
            <ContentMobile />
        </div>
        </div>

        <Footer />
        </React.Fragment>
}

const ContentMobile = () => {
    const {cusip, bondInfo, orderInfo, isRfq, isTreasuryAuction } = useOrderTicket()
    const netMoneyLabel = ['W','S'].indexOf(orderInfo.action)>=0 ? 'Estimated proceeds'
        : 'Estimated total cost'

    const issue = bondInfo.issue || {}
    const title = `Your ${isRfq ? 'quote request' : 'bond order'} has been placed`
    const priceUi = orderInfo.primary==='Y' ? orderInfo.price : orderInfo.dealerPrice

    return <React.Fragment>

        <div className="row vertical-offset-base"><div className="col-xs-12">

        <div className="vertical-offset-base" style={{backgroundColor:'#ffffff'}}>
            <div className="row vertical-offset-base"></div>

            <div className="row vertical-offset-base">
            <div className="col-md-12 text-center">
                <p>{Icons.ok}</p>
                <h2>{title}</h2>
            </div>
            </div>

            <div className="row vertical-offset-base"><div className="col-xs-12">
                <h3>Order# { orderInfo.orderNo }: <span style={{color:'green'}}>{orderInfo.orderStatusDesc}</span></h3>
            </div></div>

            <div className="row vertical-offset-base"><div className="col-xs-12">
                <div>{ fmt.mdy(new Date()) }</div>
                <div>{ parseHtml(orderInfo.accountName) }</div>
            </div></div>

            <hr aria-hidden={true} className="vertical-offset-base" />

            <Labeled label="Action" value={getAction(orderInfo.action)} />
            <Labeled label="Issuer" value={fmt.issuer({
                    issuer: parseHtml(issue.issue),
                    cusip,
                    showTradeHistory: 'Y',
                    showBondDetail: 'Y',
                    isTreasuryAuction,
                    from:'order-ticket'
                })} />
            <Labeled label="CUSIP" value={orderInfo.cusip} />
            <Labeled label="Quantity" value={fmt.qty(orderInfo.qty)} />
            <Labeled label="Execution Type" value={orderInfo.executionType} />
            <Labeled label="Settlement Date" value={orderInfo.settlement} />
            <Labeled label="Status" value={orderInfo.orderStatusDesc ? <span style={{color:'green'}}>{orderInfo.orderStatusDesc}</span> : fmt.empty() } />
            <Labeled label="Price" value={
                isTreasuryAuction ? 'Auction'
                : isNumeric(priceUi) ? '$' + fmt.price3(priceUi)
                : fmt.empty()} />

            <hr aria-hidden={true} className="vertical-offset-base" />

            <Labeled label="Principal" value={
                isTreasuryAuction ? fmt.empty() : fmt.money(isRfq? 0 : orderInfo.principal)
                } />
            <Labeled label="Accrued interest" value={
                isTreasuryAuction ? fmt.empty()
                : orderInfo.accruedInterest ? <React.Fragment>{fmt.money(orderInfo.accruedInterest)} ({fmt.count(orderInfo.accruedInterestDays)} days)</React.Fragment>
                : fmt.money(isRfq ? 0 : null)
                } />
            <Labeled label="Commission" value={
                isTreasuryAuction ? fmt.empty() : fmt.money(isRfq ? 0 : orderInfo.sugg_comm_in_dlrs_per_tckt)
                } />
            <Labeled label={netMoneyLabel} value={
                isTreasuryAuction ? fmt.empty() : fmt.money(isRfq ? 0 : orderInfo.netMoney)
                } />

            <div className="row vertical-offset-base"><div className="col-md-12 text-center">
                <Buttons />
            </div></div>

        </div>

        <div className="row vertical-offset-base"><div className="col-md-12 text-center">
            <PlaceAnotherButton />
        </div></div>

        </div></div>
        </React.Fragment>

}

const Labeled = ({label, value, style={}}) => {
    return <div className="row vertical-offset-base"><div className="col-md-12">
        <div className="text-body">{label}</div>
        <div className="label text-body text-bold" ><span style={style}>{value}</span></div>
        </div></div>
}



const Content = () => {

    const { orderInfo, isRfq} = useOrderTicket()
    const title = `Your ${isRfq ? 'quote request' : 'bond order'} has been placed`

    return <React.Fragment>
        <div className="row vertical-offset-md"><div className="col-md-12">

        <div className="container vertical-offset-base" style={{backgroundColor:'#ffffff'}}>
            <div className="row vertical-offset-base"></div>

            <div className="row vertical-offset-base">
            <div className="col-md-12 text-center">
                <p>{Icons.ok}</p>
                <h2>{title}</h2>
            </div>
            </div>

            <div className="row vertical-offset-base">
            <div className="col-md-6">
                <h3>Order# { orderInfo.orderNo }: <span style={{color:'green'}}>{orderInfo.orderStatusDesc}</span></h3>
            </div>
            <div className="col-md-6 text-right">
                <div>{ fmt.mdy(new Date()) }</div>
                <div>{ parseHtml(orderInfo.accountName) }</div>
            </div>
            </div>


            <div className="row vertical-offset-base"><div className="col-md-12">
                <Detail />
            </div></div>

            <div className="row vertical-offset-base">
                <div className="col-md-4"></div>
                <div className="col-md-4 text-center"><PlaceAnotherButton /></div>
            </div>
        </div>

        </div></div>
    </React.Fragment>
}

const Detail = () => {
    const { orderInfo, isRfq, isTreasuryAuction } = useOrderTicket()
    const netMoneyLabel = ['W','S'].indexOf(orderInfo.action)>=0 ? 'Estimated proceeds'
        : 'Estimated total cost'

    const priceUi = orderInfo.primary==='Y' ? orderInfo.price : orderInfo.dealerPrice

    return <React.Fragment>
        <div className="table-responsive">
        <table className="table align-top">
        <thead>
            <tr>
            <th className="text-body">Action</th>
            <th className="text-body"style={{maxWidth:'250px'}}>Issuer</th>
            <th className="text-body">CUSIP</th>
            <th className="text-body">Quantity</th>
            <th className="text-body">Execution type</th>
            <th className="text-body text-right">Settlement<br/>Date</th>
            <th className="text-body text-right">Status</th>
            <th className="text-body text-right">Price</th>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td className="text-body">{getAction(orderInfo.action)}</td>
            <td className="text-body text-bold" style={{maxWidth:'250px'}}>
            {fmt.issuer({
                issuer: parseHtml(orderInfo.issue),
                cusip: arrayFrom(orderInfo.cusip).join(''),
                showTradeHistory: 'Y',
                isTreasuryAuction,
                from:'orders-cancel'
            })}
            </td>
            <td className="text-body text-bold">{orderInfo.cusip}</td>
            <td className="text-body">{fmt.qty(orderInfo.qty)}</td>
            <td className="text-body">{orderInfo.executionType}</td>
            <td className="text-body text-right">{orderInfo.settlement}</td>
            <td className="text-body text-right text-bold">{
                orderInfo.orderStatusDesc
                ? <span style={{color:'green'}}>{orderInfo.orderStatusDesc}</span>
                : fmt.empty()
            }</td>
            <td className="text-body text-right text-bold">{
                isTreasuryAuction ? 'Auction'
                : isNumeric(priceUi) ? '$' + fmt.price3(priceUi)
                : fmt.empty()
            }</td>
            </tr>
            </tbody>
        </table>
        <table
            className="table align-top"
            style={{borderBottom:0}}
        >
        <tbody>
            <tr>
            <td className="text-body">
                <div>Principal</div>
                <div className="text-bold">{
                    isTreasuryAuction ? fmt.empty() : fmt.money(isRfq ? 0 : orderInfo.principal)
                }</div>
            </td>
            <td className="text-body">
                <div>Accrued interest</div>
                <div className="text-bold">{
                    isTreasuryAuction ? fmt.empty()
                    : orderInfo.accruedInterest ? <React.Fragment>{fmt.money(orderInfo.accruedInterest)} ({fmt.count(orderInfo.accruedInterestDays)} days)</React.Fragment>
                    : fmt.money(isRfq ? 0: null)
                }</div>
            </td>
            <td className="text-body">
                <div>Commission</div>
                <div className="text-bold">{
                    isTreasuryAuction ? fmt.empty() : fmt.money(isRfq ? 0 : orderInfo.sugg_comm_in_dlrs_per_tckt)
                }</div>
            </td>
            <td className="text-body">
                <div>{netMoneyLabel}</div>
                <div className="text-bold">{
                    isTreasuryAuction ? fmt.empty() : fmt.money(isRfq ? 0 : orderInfo.netMoney)
                }</div>
            </td>
            <td className="text-body text-right" colSpan={4} style={{verticalAlign:'middle'}}>
                <Buttons />
            </td>
            </tr>
        </tbody>
        </table>
        </div>
    </React.Fragment>
}

const Buttons = () => {
    const { orderInfo } = useOrderTicket()

    return <React.Fragment>
        {[
            <React.Fragment key={1}>
            <button
                data-name="cancel-link"
                className="btn btn-link text-bold"
                onClick={(e) => {
                    showModal({
                        view: 'order-detail',
                        action: 'cancel',
                        orderNo: orderInfo.orderNo,
                        source: e.target,
                    })
                }}
            >Cancel</button>
            </React.Fragment>,

            <a href="#"
                key={2}
                data-name="orders-link"
                className="btn btn-link text-bold"
                onClick={() => {
                    show('orders', { backFrom:true, _ts:Date.now()})
                }}
            >View orders</a>,

            <React.Fragment key={3}>
            <button
                data-name="orders-link"
                className="btn btn-link text-bold"
                onClick={(e) => {
                    openWindow('https://us.etrade.com/etx/pxy/portfolios/positions')
                }}
            >View portfolio</button>
            </React.Fragment>,
        ]
        .filter(Boolean)
        .flatMap( (a,i) => [a, <Sep key={i} />])
        .slice(0, -1)
        }
        </React.Fragment>
}

const PlaceAnotherButton = ({cls="btn btn-block btn-primary"} = {}) => {
    return <button
        className={cls}
        onClick={() => {
            show('order-ticket', { ts:Date.now() })
        }}
        >Place another trade</button>

}

const Sep = () => <span aria-hidden={true} style={{padding:'0 10px 0 10px'}}>|</span>

const getAction = (a) =>
    a==='F' ? <span><span className="text-bold" style={{color:'#107A1B'}}>Buy Quote</span><br/><span style={{fontWeight:'400'}}>(Offer wanted)</span></span> :
    a==='W' ? <span><span className="text-bold" style={{color:'#CC0000'}}>Sell Quote</span><br/><span style={{fontWeight:'400'}}>(Bid wanted)</span></span> :
    a==='B' ? <span className="text-bold" style={{color:'#107A1B'}}>Buy</span> :
    a==='S' ? <span className="text-bold" style={{color:'#CC0000'}}>Sell</span> :
    null

const Icons = {
    "ok": <svg aria-hidden="true" width="83" height="81" viewBox="0 0 83 81" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M41.5284 78.3871C20.1813 78.3871 2.81263 61.3915 2.81263 40.5C2.81263 19.6085 20.1813 2.6129 41.5284 2.6129C62.8755 2.6129 80.2442 19.6085 80.2442 40.5C80.2442 61.3915 62.8755 78.3871 41.5284 78.3871ZM41.5284 0C18.7075 0 0.142578 18.1688 0.142578 40.5C0.142578 62.8312 18.7075 81 41.5284 81C64.3493 81 82.9142 62.8312 82.9142 40.5C82.9142 18.1688 64.3493 0 41.5284 0ZM35.687 48.4667L28.1174 41.1689L25.5942 43.6015L35.687 53.332L57.3144 32.481L54.7912 30.0484L35.687 48.4667Z" fill="#242424"/>
    <mask id="mask0_2300_45833" style={{"maskType":"luminance"}} maskUnits="userSpaceOnUse" x="0" y="0" width="83" height="81">
    <path fillRule="evenodd" clipRule="evenodd" d="M41.5284 78.3871C20.1813 78.3871 2.81263 61.3915 2.81263 40.5C2.81263 19.6085 20.1813 2.6129 41.5284 2.6129C62.8755 2.6129 80.2442 19.6085 80.2442 40.5C80.2442 61.3915 62.8755 78.3871 41.5284 78.3871ZM41.5284 0C18.7075 0 0.142578 18.1688 0.142578 40.5C0.142578 62.8312 18.7075 81 41.5284 81C64.3493 81 82.9142 62.8312 82.9142 40.5C82.9142 18.1688 64.3493 0 41.5284 0ZM35.687 48.4667L28.1174 41.1689L25.5942 43.6015L35.687 53.332L57.3144 32.481L54.7912 30.0484L35.687 48.4667Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_2300_45833)">
    </g>
    </svg>,

}



// WEBPACK FOOTER //
// ./src/order-ticket/confirm.js